import * as MuiIcons from "@mui/icons-material";
import { Box, Button, IconButton, Tooltip, useTheme, } from "@mui/material";
import FileDownloadIcon from "@mui/icons-material/FileDownload";
import { ColDef, ColumnMovedEvent, ColumnVisibleEvent, GridReadyEvent, IServerSideGetRowsParams, SideBarDef } from "ag-grid-community";
import dayjs from "dayjs";
import FileSaver from "file-saver";
import { useCallback, useContext, useEffect, useMemo, useState } from "react";
import { useTranslation } from "react-i18next";
import { useHasScope } from "../../../../config/globalConfig";
import CustomLoader from "../../../../util/component/CustomLoader";
import SectionHeader from "../../../../util/component/SectionHeader";
import { GlobalContext } from "../../../../util/state/GlobalContextProvider";
import { setSnackbar } from "../../../../util/state/globalAction";
import { snackbarTypes } from "../../../../util/state/globalVariables";
import { ContextOperation } from "../../context/OperationContext";
import useSnackbar from "../../hooks/useSnackbar";
import useToggle from "../../hooks/useToggle";
import { vehicleActions } from "../../service/vehicle.actions";
import AttachmentsVehicle from "../attachmentsVehicles/AttachmentsVehiclesTable";
import { AutoCompleteOption } from "../common/AutoComplete";
import AgGridOperationTable from "../common/AgGridOperationTable";
import { EXPIRED_DEFAULT_COL_DEF, OperationScope } from "../../config";
import ChecklistModal from "../Vehicle/ChecklistModal";
import CviFormDialogWrapper from "../Vehicle/CviFormDialog";
import DownloadModal from "../Vehicle/DownloadModal";
import DownloadModalMassiveLock from "../Vehicle/DownloadModalMassiveLock";
import EditVehicle from "../Vehicle/EditVehicle";
import EquipmentsModal from "../Vehicle/EquipmentsModal";
import FiltersModal from "../Vehicle/FiltersModal";
import FirstFueling from "../Vehicle/FirstFuelingModal";
import { FirstFuelingType } from "../Vehicle/FirstFuelingType";
import MaintenaceModal from "../Vehicle/MaintenaceModal";
import VehicleModal from "../Vehicle/VehicleModal";
import { IChooseVehicle } from "../Vehicle/VehicleSearch";
import { CarsharingRedirectParams, redirectToCarsharing } from "../../../../util/carsharingService";

const VehicleCarSharingSearch = (props: any) => {
  const hasScope = useHasScope;
  const snackbar = useSnackbar();
  const { tenant } = useContext(ContextOperation);
  const { t, i18n } = useTranslation(["operation"]);
  const [loading, setIsLoading] = useState(false);
  const [modalData, setModalData] = useState<any>([]);
  const [openModal, setOpenModal] = useState(false);
  const [length, setLength] = useState<number>(0);
  const [gridApi, setGridApi] = useState<any>(null);
  const [refreshData, setRefreshData] = useState<boolean>(false);
  const [pageSize, setPageSize] = useState<number>(10);
  const [success, setSuccess] = useState<boolean>(false);
  const [filter, setFilter] = useState<boolean>(false);
  const [maintenaceData, setMaintenaceData] = useState<any>({});
  const { dispatchGlobalData, globalData } = useContext(GlobalContext);
  const theme = useTheme();
  const [openMaintenaceModal, setOpenMaintenaceModal] = useState<boolean>(false);
  const [openEquipmentsModal, setOpenEquipmentsModal] = useState<boolean>(false);
  const [openVehicleAttachment, setOpenVehicleAttachment] = useState<boolean>(false);
  const [openChecklistModal, setOpenChecklistModal] = useState<boolean>(false);
  const [chooseVehicle, setChooseVehicle] = useState<IChooseVehicle>();
  const [selectedVehicle, setSelectedVehicle] = useState<any>({});
  const [vehicleId, setVehicleId] = useState<any>({});
  const [showEdit, toggleEdit] = useToggle();
  const [tireType, setTireType] = useState<AutoCompleteOption[]>([]);
  const [selecedAnVehicle, setSelectedAnVehicle] = useState<any>({
    plate: "",
    vin: "",
    brand: "",
    model: "",
  });
  const [data, setData] = useState<any>({
    brand: { id: "", descr: "" },
    model: { id: "", descr: "" },
    carSegment: { id: "", descr: "" },
    carClass: { id: "", descr: "" },
    carAcriss: { id: "", code: "" },
    carSipp: { id: "", code: "" },
    plate: "",
    vin: "",
    imeiPrimary: "",
    imeiSecondary: "",
    currentTireType: { code: "", description: "" },
    expectedSaleDateFrom: null,
    expectedSaleDateTo: null,
    inFleet: { id: "true", descr: t("internOptionSelectName.yes") },
    vehicleStatus: { id: "", descr: "" },
    firstFuelingDone: { id: "", descr: "" },
    enginePowerGroupCodes: [],
    reasonCode: [],
    ownership: "",
    extColor: "",
    registrationDateFrom: "",
    registrationDateTo: "",
    realDeliveryDateFrom: "",
    realDeliveryDateTo: "",
    basket: [],
    cityId: [],
    keyless: ""
  });
  const [openDownloadModal, setOpenDownloadModal] = useToggle();
  const [openDownloadModalMassiveLock, setOpenDownloadModalMassiveLock] = useToggle();
  const [maintenaceDataArray, setMaintenaceDataArray] = useState<any>([]);
  const [firstFueling, setFirstFueling] = useState<boolean>(false);
  const [resetPower, setResetPower] = useState<boolean>(false);
  const [fuelingData, setFuelingData] = useState<
    FirstFuelingType.Data | undefined
  >();
  const [openMaintenanceData, setOpenMaintenanceData] = useState<boolean>(false);
  const [openVehicleCommandData, setOpenVehicleCommandData] = useState<boolean>(false);//P.N.

  const maintenaceAction = vehicleActions();

  const hasVehicleDetailRedirectScope = useHasScope(OperationScope.CsRedirectVehicleDetail);
  const hasLogFileHistoryScope = useHasScope(OperationScope.CsLogFileHistory);
  const hasMoveHistoryScope = useHasScope(OperationScope.CsMoveHistory);
  const hasCommandHistoryScope = useHasScope(OperationScope.CsCommandHistory);
  const hasReportManagementScope = useHasScope(OperationScope.CsReportManagement);
  const hasJiraManagementScope = useHasScope(OperationScope.CsJiraManagement);
  const hasAlarmsWarningScope = useHasScope(OperationScope.CsAlarmsWarning);
  const hasCustomerReservationsScope = useHasScope(OperationScope.CsCustomerReservations);
  const hasOperatorReservationsScope = useHasScope(OperationScope.CsOperatorReservations);

  const onSubmit = () => {
    onSearch();
  };

  const cancel = () => {
    setData({
      brand: { id: "", descr: "" },
      model: { id: "", descr: "" },
      carSegment: { id: "", descr: "" },
      carClass: { id: "", descr: "" },
      carAcriss: { id: "", code: "" },
      carSipp: { id: "", code: "" },
      plate: "",
      vin: "",
      imeiPrimary: "",
      imeiSecondary: "",
      currentTireType: { code: "", description: "" },
      expectedSaleDateFrom: null,
      expectedSaleDateTo: null,
      // inFleet: { id: "true", descr: `${t("internOptionSelectName.yes")}` },
      vehicleStatus: { id: "", descr: "" },
      firstFuelingDone: { id: "", descr: "" },
      enginePowerGroupCodes: [],
      ownership: "",
      extColor: "",
      registrationDateFrom: "",
      registrationDateTo: "",
      realDeliveryDateFrom: "",
      realDeliveryDateTo: "",
      keyless: "",
      basket: [],
      cityId: []
    });
    setFilter(!filter);
    setResetPower(true);
  };

  function onSearch() {
    setResetPower(false);

    let engineId: any = [];
    data.enginePowerGroupCodes.map((el: any) => engineId.push(el.value));
    console.log(engineId, "engineId");

    let brandId = data.brand.id ? data.brand.id : null;
    let modelId = data.model.id ? data.model.id : null;
    let carSegmentId = data.carSegment.id ? data.carSegment.id : null;
    let carClassId = data.carClass.id ? data.carClass.id : null;
    let acrissId = data.carAcriss.id ? data.carAcriss.id : null;
    let customAcrissId = data.carSipp.id ? data.carSipp.id : null;
    let vin = data.vin ? data.vin.trim() : null;
    let plate = data.plate ? data.plate.trim() : null;
    let imeiPrimary = data.imeiPrimary ? data.imeiPrimary.trim() : null;
    let imeiSecondary = data.imeiSecondary ? data.imeiSecondary.trim() : null;
    let currentTireTypeCode = data.currentTireType.code ? data.currentTireType.code : null;
    let expectedSaleDateFrom = dayjs(data?.expectedSaleDateFrom).isValid() ? dayjs(data?.expectedSaleDateFrom).format("YYYY-MM-DD") : null;
    let expectedSaleDateTo = dayjs(data?.expectedSaleDateTo).isValid() ? dayjs(data?.expectedSaleDateTo).format("YYYY-MM-DD") : null;
    let inFleet = !!data.inFleet?.id ? data.inFleet.id : null;
    let vehicleStatusId = data.vehicleStatus.id ? data.vehicleStatus.id : null;
    let firstFuelingDoneId = data.firstFuelingDone.id ? data.firstFuelingDone.id : null;
    let enginePowerGroupCodes = engineId.length > 0 ? engineId.toString() : null;

    let ownership = data.ownership ? data.ownership : null;
    let extColor = data.extColor ? encodeURI(data.extColor.trim()) : null;
    let registrationDateFrom = dayjs(data?.registrationDateFrom).isValid() ? dayjs(data?.registrationDateFrom).format("YYYY-MM-DD") : null;
    let registrationDateTo = dayjs(data?.registrationDateTo).isValid() ? dayjs(data?.registrationDateTo).format("YYYY-MM-DD") : null;
    let realDeliveryDateFrom = dayjs(data?.realDeliveryDateFrom).isValid() ? dayjs(data?.realDeliveryDateFrom).format("YYYY-MM-DD") : null;
    let realDeliveryDateTo = dayjs(data?.realDeliveryDateTo).isValid() ? dayjs(data?.realDeliveryDateTo).format("YYYY-MM-DD") : null;
    let keyless = data.keyless === '' ? undefined : Boolean(data.keyless);
    let basket = data.basket ?? null;
    let cityId = data.cityId ?? null;

    setIsLoading(true);

    return {
      getRows: async (serverSide: IServerSideGetRowsParams) => {
        const startRow = serverSide.request.startRow ?? 0;
        const endRow = serverSide.request.endRow;

        const sortCode = serverSide.request.sortModel[0]?.colId;
        const sortDirection = serverSide.request.sortModel[0]?.sort;

        let pageSize = 10;
        if (
          endRow !== null &&
          endRow !== undefined &&
          startRow !== null &&
          startRow !== undefined
        ) {
          pageSize = endRow - startRow;
        }
        const pageNumber = startRow / pageSize;
        vehicleActions()
          .getAllCsVehicle(
            tenant,
            pageSize,
            pageNumber,
            sortCode,
            sortDirection,
            brandId,
            modelId,
            carSegmentId,
            carClassId,
            acrissId,
            customAcrissId,
            vin,
            plate,
            imeiPrimary,
            imeiSecondary,
            currentTireTypeCode,
            expectedSaleDateFrom,
            expectedSaleDateTo,
            // inFleet,
            vehicleStatusId,
            firstFuelingDoneId,
            enginePowerGroupCodes,
            data.reasonCode,
            ownership,
            extColor,
            registrationDateFrom,
            registrationDateTo,
            realDeliveryDateFrom,
            realDeliveryDateTo,
            keyless,
            basket,
            cityId
          )
          .then((response: any) => {
            serverSide.successCallback(
              manageData(response.data.content),
              response.data.totalElements
            );
            setLength(response.data.totalElements);
            setIsLoading(false);
          })
          .catch((error: any) => {
            if (error.response) {
              dispatchGlobalData({
                type: setSnackbar,
                payload: {
                  snackbar: {
                    message: error.response.data.msg,
                    type: snackbarTypes.error,
                    show: true,
                    autoClose: true,
                  },
                },
              });
              setIsLoading(false);
            } else if (error.request) {
              dispatchGlobalData({
                type: setSnackbar,
                payload: {
                  snackbar: {
                    message: t("networkErrorMessage"),
                    type: snackbarTypes.error,
                    show: true,
                    autoClose: true,
                  },
                },
              });
              setIsLoading(false);
            } else {
              setIsLoading(false);
            }
          });
      },
    };
  }

  useEffect(() => {
    if (gridApi) {
      gridApi.setServerSideDatasource(onSearch());
    }
  }, [gridApi, filter, refreshData]);

  useEffect(() => {
    vehicleActions()
      .getAllTireType()
      .then((responceTireType: any) => {
        setTireType(
          responceTireType.data.map((res: any) => ({
            value: res.code,
            label: res.description,
          }))
        );
      });
  }, []);

  function downloadExcel() {
    setIsLoading(true);
    let engineId: any = [];
    if (data.enginePowerGroupCodes !== null) {
      data.enginePowerGroupCodes.map((el: any) => engineId.push(el.value));
    }
    let brandId = data.brand.id ? data.brand.id : null;
    let modelId = data.model.id ? data.model.id : null;
    let carSegmentId = data.carSegment.id ? data.carSegment.id : null;
    let carClassId = data.carClass.id ? data.carClass.id : null;
    let acrissId = data.carAcriss.id ? data.carAcriss.id : null;
    let customAcrissId = data.carSipp.id ? data.carSipp.id : null;
    let vin = data.vin ? data.vin : null;
    let plate = data.plate ? data.plate : null;
    let imeiPrimary = data.imeiPrimary ? data.imeiPrimary : null;
    let imeiSecondary = data.imeiSecondary ? data.imeiSecondary : null;
    let currentTireTypeCode = data.currentTireType.code ? data.currentTireType.code : null;
    let expectedSaleDateFrom = dayjs(data?.expectedSaleDateFrom).isValid() ? dayjs(data?.expectedSaleDateFrom).format("YYYY-MM-DD") : null;
    let expectedSaleDateTo = dayjs(data?.expectedSaleDateTo).isValid() ? dayjs(data?.expectedSaleDateTo).format("YYYY-MM-DD") : null;
    let inFleet = data.inFleet?.id;
    let vehicleStatusId = data.vehicleStatus.id ? data.vehicleStatus.id : null;
    let firstFuelingDoneId = data.firstFuelingDone.id ? data.firstFuelingDone.id : null;
    let enginePowerGroupCodes = engineId.length > 0 ? engineId.toString() : null;

    let ownership = data.ownership ? data.ownership : null;
    let extColor = data.extColor ? encodeURI(data.extColor) : null;
    let registrationDateFrom = dayjs(data?.registrationDateFrom).isValid() ? dayjs(data?.registrationDateFrom).format("YYYY-MM-DD") : null;
    let registrationDateTo = dayjs(data?.registrationDateTo).isValid() ? dayjs(data?.registrationDateTo).format("YYYY-MM-DD") : null;
    let realDeliveryDateFrom = dayjs(data?.realDeliveryDateFrom).isValid() ? dayjs(data?.realDeliveryDateFrom).format("YYYY-MM-DD") : null;
    let realDeliveryDateTo = dayjs(data?.realDeliveryDateTo).isValid() ? dayjs(data?.realDeliveryDateTo).format("YYYY-MM-DD") : null;
    let keyless = data.keyless === '' ? undefined : Boolean(data.keyless);
    let basket = data.basket ?? null;
    let cityId = data.cityId ?? null;

    vehicleActions()
      .exportDataCarSharingVehicle(
        i18n.language,
        tenant,
        brandId,
        modelId,
        carSegmentId,
        carClassId,
        acrissId,
        customAcrissId,
        vin,
        plate,
        // inFleet,
        vehicleStatusId,
        currentTireTypeCode,
        expectedSaleDateFrom,
        expectedSaleDateTo,
        imeiPrimary,
        imeiSecondary,
        firstFuelingDoneId,
        enginePowerGroupCodes,
        data.reasonCode,
        ownership,
        extColor,
        registrationDateFrom,
        registrationDateTo,
        realDeliveryDateFrom,
        realDeliveryDateTo,
        keyless,
        data.basket,
        data.cityId
      )
      .then((response: any) => {
        setIsLoading(false);
        if (response.status === 200) {
          const filename =
            response.headers["content-disposition"].split("filename=")[1];
          var blob = new Blob([response.data], {
            type: "application/vnd.openxmlformats-officedocument.spreadsheetml.sheet",
          });
          FileSaver.saveAs(blob, filename);
        } else setOpenDownloadModal();
      });
  }

  function getLabelCenterStatus(rtState: number, status: number) {
    if (rtState === 0) {
      switch (status) {
        case 0:
          return t("carSharing.status.i18nClosed") + " (" + t("carSharing.status.i18nFree") + ")";
        case 1:
          return t("carSharing.status.i18nVehicleBooked");
        case 3:
          return t("carSharing.status.i18nOnTrasmitting");
        case 13:
          return t("carSharing.status.i18nSchedulated");
        case 14:
          return t("carSharing.status.i18nOnTrasmitting");
        case 8:
          return t("carSharing.status.i18nResendBooking");
        case 18:
          return t("carSharing.status.i18nVehicleNotPickedUp") + " (" + t("carSharing.status.i18nFree") + ")";
        case 17:
          return t("carSharing.status.i18nPinProblem") + " (" + t("carSharing.status.i18nFree") + ")";
        case 6:
          return t("carSharing.status.i18nOnDeleting");
        case 16:
          return t("carSharing.status.i18nWaitingForResponse");
        default:
          return t("carSharing.status.i18nUndefined");
      }
    } else if (rtState === 1) {
      switch (status) {
        case 19:
          return t("carSharing.status.i18nDeleted") + " (" + t("carSharing.status.i18nFree") + ")";
        default:
          return t("carSharing.status.i18nUndefined");
      }
    } else if (rtState === 2) {
      switch (status) {
        case 7:
          return t("carSharing.status.i18nFailed") + " (" + t("carSharing.status.i18nFree") + ")";
        default:
          return t("carSharing.status.i18nUndefined");
      }
    } else if (rtState === 3) {
      switch (status) {
        case 4:
          return t("carSharing.status.i18nClosed") + " (" + t("carSharing.status.i18nFree") + ")";
        case 9:
          return t("carSharing.status.i18nBookingExpired") + " (" + t("carSharing.status.i18nFree") + ")";
        default:
          return t("carSharing.status.i18nUndefined");
      }
    } else if (rtState === 4) {
      switch (status) {
        case 10:
          return t("carSharing.status.i18nOnRunning");
        case 12:
          return t("carSharing.status.i18nOnTrasmitting");
        default:
          return t("carSharing.status.i18nUndefined");
      }
    } else {
      return t("carSharing.status.i18nUndefined");
    }
  }

  function getLabelChargingStatus(chargingStatus: string) {
    switch (chargingStatus) {
      case "CHARGING":
        return t("carSharing.status.i18nCharging");
      case "NOT_CHARGING":
        return t("carSharing.status.i18nNotCharging");
      case "CHARGE_FAULT":
        return t("carSharing.status.i18nChargeFault");
      case "CHARGE_COMPLETE":
        return t("carSharing.status.i18nChargeComplete");
      case "CHARGE_INTERRUPT":
        return t("carSharing.status.i18nChargeInterrupt");
      case "SNA":
        return t("carSharing.status.i18nSignalNotAvailable");
      default:
        return chargingStatus;
    }
  }

  function getLabelDoorStatus(door_status: number) {
    if (door_status !== undefined && door_status !== null) {
      return door_status == 1 ? t("carSharing.status.i18nDoorsIsClosed") : t("carSharing.status.i18nDoorsIsOpen");
    }
    return "";
  }

  function getLabelEngineStatus(crank_status: number) {
    if (crank_status !== undefined && crank_status !== null) {
      return crank_status == 1 ? t("carSharing.status.i18nLock") : t("carSharing.status.i18nUnlock");
    }
    return "";
  }

  function getLabelTelematics(imei: string) {
    if (imei !== undefined && imei !== null && imei !== "") {
      return t("carSharing.status.i18nObuOcto");
    }
    return t("carSharing.status.i18nTbmStellantis");
  }

  function getCsSection(dism: number, freefloating: number, oos: number, oof: string) {
    if (dism === 1) {
      return 'DISMITTED'
    } else if (freefloating === 1) {
      return 'FREE_FLOATING';
    } else if (oos === 1) {
      return 'OUT_OF_SERVICE'
    } else if (oof === "OUT_OF_FLEET") {
      return 'OUT_OF_FLEET'
    }

    // throw ("No section found");

    console.error("No section found");
    return 'OUT_OF_FLEET';
  }

  function manageData(data: any) {
    if (data !== undefined) {
      let rows: any = [];
      data.forEach((element: any) => {
        const elem = element.vehicle;
        const c2cElement = element.c2cInfo.vehicleMap;
        const c2cSource = element.c2cInfo.source;
        let row = {
          id: elem?.id,
          plate: c2cElement?.plate,
          vin: c2cElement?.vin,
          caridentifier: c2cElement?.caridentifier,
          center_status: getLabelCenterStatus(c2cElement?.rstate, c2cElement?.status),
          parcheggio: c2cElement?.parcheggio,
          address: c2cElement?.address,
          fuel_level: c2cElement?.fuel_level,
          odometer: c2cElement?.vsFca?.odometer,
          charging_status: getLabelChargingStatus(c2cElement?.vsFca?.charge_status),
          momcaption: c2cElement?.momcaption,
          telematics: getLabelTelematics(c2cElement?.imei),
          door_status: getLabelDoorStatus(c2cElement?.vsFca?.doors_status),
          engine_status: getLabelEngineStatus(c2cElement?.vsFca?.crank_status),
          section: getCsSection(c2cElement?.dism, c2cElement?.freefloating, c2cElement?.oos, c2cSource)
        };
        rows.push(row);
      });
      return rows;
    }
  }

  const defaultColDef = useMemo<ColDef>(() => EXPIRED_DEFAULT_COL_DEF, []);

  const columns: ColDef[] = useMemo<ColDef[]>(() => [
    {
      field: "_action",
      headerName: "",
      sortable: false,
      minWidth: 235,
      pinned: "left",
      suppressMovable: true,
      suppressColumnsToolPanel: true,
      cellRendererSelector: (params: any) => {
        const onClickWorld = async () => {
          const redirectParams: CarsharingRedirectParams = {
            lang: i18n.language,
            type: 'VEHICLE',
            section: 'MAP',
            id: params.data.plate,
          };

          try {
            await redirectToCarsharing(redirectParams);
          } catch (error) {
            console.error('Redirect failed:', error);
          }
        };

        const onClickList = async () => {
          const redirectParams: CarsharingRedirectParams = {
            lang: i18n.language,
            type: 'VEHICLE',
            section: params.data.section,
            id: params.data.plate,
            shortcut: ''
          };

          try {
            await redirectToCarsharing(redirectParams);
          } catch (error) {
            console.error('Redirect failed:', error);
          }
        };

        const onClickDetail = async () => {
          const redirectParams: CarsharingRedirectParams = {
            lang: i18n.language,
            type: 'VEHICLE',
            section: params.data.section,
            id: params.data.plate,
            shortcut: 'VEHICLE_DETAIL'
          };

          try {
            await redirectToCarsharing(redirectParams);
          } catch (error) {
            console.error('Redirect failed:', error);
          }
        };

        const onClickMovementHistory = async () => {
          const redirectParams: CarsharingRedirectParams = {
            lang: i18n.language,
            type: 'VEHICLE',
            section: params.data.section,
            id: params.data.plate,
            shortcut: 'MOVE_HISTORY'
          };

          try {
            await redirectToCarsharing(redirectParams);
          } catch (error) {
            console.error('Redirect failed:', error);
          }
        };

        const onClickVehicleUsageHistory = async () => {
          const redirectParams: CarsharingRedirectParams = {
            lang: i18n.language,
            type: 'VEHICLE',
            section: params.data.section,
            id: params.data.plate,
            shortcut: 'LOG_FILE_HISTORY'
          };

          try {
            await redirectToCarsharing(redirectParams);
          } catch (error) {
            console.error('Redirect failed:', error);
          }
        };

        const onClickCommandHistory = async () => {
          const redirectParams: CarsharingRedirectParams = {
            lang: i18n.language,
            type: 'VEHICLE',
            section: params.data.section,
            id: params.data.plate,
            shortcut: 'COMMAND_HISTORY'
          };

          try {
            await redirectToCarsharing(redirectParams);
          } catch (error) {
            console.error('Redirect failed:', error);
          }
        };

        const onClickJira = async () => {
          const redirectParams: CarsharingRedirectParams = {
            lang: i18n.language,
            type: 'VEHICLE',
            section: params.data.section,
            id: params.data.plate,
            shortcut: 'JIRA_MANAGEMENT'
          };

          try {
            await redirectToCarsharing(redirectParams);
          } catch (error) {
            console.error('Redirect failed:', error);
          }
        };

        return {
          component: () => (
            <>
              {hasVehicleDetailRedirectScope &&
                <Tooltip
                  title={t("deliveryNote.table.tooltip.globe")}
                  placement={"left"}
                  arrow={true}
                >
                  <Button variant="text" size="icon" onClick={onClickWorld}>
                    <MuiIcons.Public />
                  </Button>
                </Tooltip>
              }
              {hasVehicleDetailRedirectScope &&
                <Tooltip
                  title={t("deliveryNote.table.tooltip.list")}
                  placement={"left"}
                  arrow={true}
                >
                  <Button variant="text" size="icon" onClick={onClickList}>
                    <MuiIcons.List />
                  </Button>
                </Tooltip>
              }
              {hasVehicleDetailRedirectScope &&
                <Tooltip
                  title={t("deliveryNote.table.tooltip.detail")}
                  placement={"left"}
                  arrow={true}
                >
                  <Button variant="text" size="icon" onClick={onClickDetail}>
                    <MuiIcons.ListAlt />
                  </Button>
                </Tooltip>
              }
              {hasMoveHistoryScope &&
                <Tooltip
                  title={t("deliveryNote.table.tooltip.movementHistory")}
                  placement={"left"}
                  arrow={true}
                >
                  <Button variant="text" size="icon" onClick={onClickMovementHistory}>
                    <MuiIcons.ZoomOutMap />
                  </Button>
                </Tooltip>
              }
              {hasLogFileHistoryScope &&
                <Tooltip
                  title={t("deliveryNote.table.tooltip.vehicleUsageHistory")}
                  placement={"left"}
                  arrow={true}
                >
                  <Button variant="text" size="icon" onClick={onClickVehicleUsageHistory}>
                    <MuiIcons.DirectionsCar />
                  </Button>
                </Tooltip>
              }
              {hasCommandHistoryScope &&
                <Tooltip
                  title={t("deliveryNote.table.tooltip.commandHistory")}
                  placement={"left"}
                  arrow={true}
                >
                  <Button variant="text" size="icon" onClick={onClickCommandHistory}>
                    <MuiIcons.Terminal />
                  </Button>
                </Tooltip>
              }
              {hasJiraManagementScope &&
                <Tooltip
                  title={t("deliveryNote.table.tooltip.jira")}
                  placement={"left"}
                  arrow={true}
                >
                  <Button variant="text" size="icon" onClick={onClickJira}>
                    <MuiIcons.ShapeLine />
                  </Button>
                </Tooltip>
              }
            </>
          )
        }
      },
    },
    {
      field: "plate",
      headerName: t("carSharing.plate"),
      minWidth: 100,
      cellRenderer: (params: any) => (
        <Tooltip title={params.data.plate}>
          <span>{params.data.plate}</span>
        </Tooltip>
      ),
    },
    {
      field: "vin",
      headerName: t("carSharing.vin"),
      minWidth: 200,
      cellRenderer: (params: any) => (
        <Tooltip title={params.data.vin}>
          <span>{params.data.vin}</span>
        </Tooltip>
      ),
    },
    {
      field: "caridentifier",
      headerName: t("carSharing.caridentifier"),
      minWidth: 200,
      cellRenderer: (params: any) => (
        <Tooltip title={params.data.caridentifier}>
          <span>{params.data.caridentifier}</span>
        </Tooltip>
      ),
    },
    {
      field: "center_status",
      headerName: t("carSharing.center_status"),
      minWidth: 200,
      cellRenderer: (params: any) => (
        <Tooltip title={params.data.center_status}>
          <span>{params.data.center_status}</span>
        </Tooltip>
      ),
    },
    {
      field: "parcheggio",
      headerName: t("carSharing.parcheggio"),
      minWidth: 200,
      cellRenderer: (params: any) => (
        <Tooltip title={params.data.parcheggio}>
          <span>{params.data.parcheggio}</span>
        </Tooltip>
      ),
    },
    {
      field: "address",
      headerName: t("carSharing.address"),
      minWidth: 200,
      cellRenderer: (params: any) => (
        <Tooltip title={params.data.address}>
          <span>{params.data.address}</span>
        </Tooltip>
      ),
    },
    {
      field: "fuel_level",
      headerName: t("carSharing.fuel_level"),
      minWidth: 200,
      cellRenderer: (params: any) => (
        <Tooltip title={params.data.fuel_level}>
          <span>{params.data.fuel_level}</span>
        </Tooltip>
      ),
    },
    {
      field: "odometer",
      headerName: t("carSharing.odometer"),
      minWidth: 200,
      cellRenderer: (params: any) => (
        <Tooltip title={params.data.odometer}>
          <span>{params.data.odometer}</span>
        </Tooltip>
      ),
    },
    {
      field: "charging_status",
      headerName: t("carSharing.charging_status"),
      minWidth: 200,
      cellRenderer: (params: any) => (
        <Tooltip title={params.data.charging_status}>
          <span>{params.data.charging_status}</span>
        </Tooltip>
      ),
    },
    {
      field: "momcaption",
      headerName: t("carSharing.momcaption"),
      minWidth: 200,
      cellRenderer: (params: any) => (
        <Tooltip title={params.data.momcaption}>
          <span>{params.data.momcaption}</span>
        </Tooltip>
      ),
    },
    {
      field: "telematics",
      headerName: t("carSharing.telematics"),
      minWidth: 200,
      cellRenderer: (params: any) => (
        <Tooltip title={params.data.telematics}>
          <span>{params.data.telematics}</span>
        </Tooltip>
      ),
    },
    {
      field: "door_status",
      headerName: t("carSharing.door_status"),
      minWidth: 200,
      cellRenderer: (params: any) => (
        <Tooltip title={params.data.door_status}>
          <span>{params.data.door_status}</span>
        </Tooltip>
      ),
    },
    {
      field: "engine_status",
      headerName: t("carSharing.engine_status"),
      minWidth: 200,
      cellRenderer: (params: any) => (
        <Tooltip title={params.data.engine_status}>
          <span>{params.data.engine_status}</span>
        </Tooltip>
      ),
    },
    {
      field: "csBasket",
      headerName: t("vehicle.csBasket"),
      minWidth: 120,
      cellRenderer: (params: any) => (
        <Tooltip title={t(`carSharing.basket.${params.data.section}`)}>
          <span>{t(`carSharing.basket.${params.data.section}`)}</span>
        </Tooltip>
      ),
    },
    {
      field: "id",
      headerName: "Id",
      minWidth: 100,
      sortable: false,
      hide: true,
    },
    {
      field: "_action",
      headerName: "",
      sortable: false,
      maxWidth: 100,
      minWidth: 100,
      pinned: "right",
      suppressMovable: true,
      suppressColumnsToolPanel: true,
      cellRendererSelector: (params: any) => {
        const onClickDetails = (e: any) => {
          setIsLoading(true);
          e.stopPropagation();
          vehicleActions()
            .getVehicleById(tenant, params.data.id)
            .then((res: any) => {
              setIsLoading(false);
              setModalData(res.data);
              setOpenModal(true);
            });
        };

        return {
          component: () => (
            <Tooltip
              title={t("deliveryNote.table.tooltip.details")}
              placement={"left"}
              arrow={true}
            >
              <Button variant="text" size="icon" onClick={onClickDetails}>
                <MuiIcons.Description />
              </Button>
            </Tooltip>
          )
        }
      },
    },
  ], [tenant]);

  const sideBar = useMemo<SideBarDef>(() => ({
    toolPanels: [
      {
        id: 'columns',
        labelDefault: 'Columns',
        labelKey: 'columns',
        iconKey: 'columns',
        toolPanel: 'agColumnsToolPanel',
        toolPanelParams: {
          suppressRowGroups: true,
          suppressValues: true,
          suppressPivots: true,
          suppressPivotMode: true,
          suppressColumnExpandAll: true,
        },
      },
    ],
    defaultToolPanel: '',
    position: 'right'
  }), []);

  const columnStateStorageKey = useMemo(() => {
    return `__OPERATION_PENDING.vehicleSearchTableColumsConfig:${globalData.user.username}`;
  }, [globalData.user.username]);

  const onGridReady = useCallback((event: GridReadyEvent) => {
    const colState = JSON.parse(localStorage.getItem(columnStateStorageKey) || '[]');

    event.columnApi.applyColumnState({
      state: colState,
      applyOrder: true
    });

    event.api.sizeColumnsToFit();
    setGridApi(event.api);
  }, [columnStateStorageKey]);

  const onColumnVisible = useCallback((event: ColumnVisibleEvent) => {
    localStorage.setItem(columnStateStorageKey, JSON.stringify(event.columnApi.getColumnState()));
  }, [columnStateStorageKey]);

  const onColumnMoved = useCallback((event: ColumnMovedEvent) => {
    localStorage.setItem(columnStateStorageKey, JSON.stringify(event.columnApi.getColumnState()));
  }, [columnStateStorageKey]);

  const showMaintenace = () => {
    if (openMaintenanceData) setOpenMaintenaceModal(true);
  };

  const getQueryParam = (param: string): boolean => {
    const urlParams = new URLSearchParams(window.location.search);
    return !(urlParams.get(param)?.toLowerCase() === 'true'); // Gestisce anche valori con maiuscole/minuscole
  };

  const getReadonlyCommand = (name: string, param: any): boolean => {
    const urlParams = new URLSearchParams(window.location.search);
    const qNameVal = (urlParams.get(name)?.toLowerCase() === 'true'); //p.n. da sostituire con il profilo
    if ((qNameVal || hasScope("SCOPE_VEHICLE_SEND_COMMAND")) && param?.reasonCodes && param?.keyless === 1) {
      return ['ORE'].includes(param?.reasonCodes);
    }
    return true;
  };

  const getMaintenaceDataById = (maintenace: any) => {
    setIsLoading(true);
    setOpenMaintenanceData(true);
    maintenaceAction
      .getMainTenanceById(tenant, maintenace.data.id)
      .then((response: any) => {
        setMaintenaceDataArray(response.data.maintenances);
        setIsLoading(false);
      });
    setMaintenaceData(maintenace.data);
  };

  useEffect(showMaintenace, [maintenaceDataArray]);

  const downloadTemplate = (): void => {
    setIsLoading(true);
    maintenaceAction
      .downloadTemplate(tenant)
      .then((response: any) => {
        setIsLoading(false);
        const filename =
          response?.headers["content-disposition"].split("filename=")[1];
        var blob = new Blob([response.data], {
          type: "application/vnd.openxmlformats-officedocument.spreadsheetml.sheet",
        });
        FileSaver.saveAs(blob, filename);
      })
      .catch(() => {
        setIsLoading(false);
        dispatchGlobalData({
          type: setSnackbar,
          payload: {
            snackbar: {
              message: t("vehicle.templateButton.fail"),
              type: snackbarTypes.error,
              show: true,
              autoClose: true,
            },
          },
        });
      });
  };

  const onPriceListChange = (event: any) => {
    if (event.target.files && event.target.files[0]) {
      let priceList = event.target.files[0];
      const formData = new FormData();
      formData.append("file", priceList);

      if (priceList) {
        setIsLoading(true);
        maintenaceAction
          .uploadPriceList(tenant, formData)
          .then((response: any) => {
            setIsLoading(false);
            if (response.status === 200) {
              const filename =
                response.headers["content-disposition"].split("filename=")[1];
              var blob = new Blob([response.data], {
                type: "application/vnd.openxmlformats-officedocument.spreadsheetml.sheet",
              });
              FileSaver.saveAs(blob, filename);
            } else setOpenDownloadModalMassiveLock();
          })
          .catch((error: any) => {
            setIsLoading(false);
            dispatchGlobalData({
              type: setSnackbar,
              payload: {
                snackbar: {
                  message: t("vehicle.templateButton.uploadFail"),
                  type: snackbarTypes.error,
                  show: true,
                  autoClose: true,
                },
              },
            });
          });
      }
      event.target.value = null;
    }
  };

  return (
    <>
      {!openVehicleAttachment ? (
        <div>
          <SectionHeader title={t("vehicle.csTitleFirst")} />
          <FiltersModal
            filtersToParent={setData}
            data={data}
            setData={setData}
            cancel={cancel}
            setFilter={setFilter}
            filter={filter}
            tenant={tenant}
            resetPower={resetPower}
            isCs={true}
          />

          <Box
            minHeight={46}
            pr={1}
            display="flex"
            justifyContent={"flex-end"}
            alignItems="center"
          >
            <Tooltip title={t("tooltipTitle.download")}>
              <IconButton
                color="accent"
                disabled={length === 0}
                onClick={downloadExcel}
              >
                <FileDownloadIcon />
              </IconButton>
            </Tooltip>
          </Box>

          <Box className="carBrandOuterTableBox">
            <AgGridOperationTable
              columnDefs={columns}
              defaultColDef={defaultColDef}
              onColumnVisible={onColumnVisible}
              onColumnMoved={onColumnMoved}
              onGridReady={onGridReady}
              cacheBlockSize={pageSize}
              serverSideInfiniteScroll={true}
              rowModelType={"serverSide"}
              totalElements={length}
              sideBar={sideBar}
            />

          </Box>
        </div>
      ) : (
        <AttachmentsVehicle
          tenant={tenant}
          selectedAnVehicle={selecedAnVehicle}
          id={vehicleId}
          setOpenVehicleAttachment={setOpenVehicleAttachment}
        //closeModal={setOpenEquipmentsModal}
        />
      )}
      {loading && <CustomLoader loading={loading} />}
      {openModal && (
        <VehicleModal
          tenant={tenant}
          closeModal={setOpenModal}
          data={modalData}
          childToParent={setSuccess}
          tireType={tireType}
        />
      )}
      {openMaintenaceModal && (
        <MaintenaceModal
          tenant={tenant}
          closeModal={setOpenMaintenaceModal}
          maintenaceDataArray={maintenaceDataArray}
          maintenaceData={maintenaceData}
        />
      )}
      {openEquipmentsModal && (
        <EquipmentsModal
          tenant={tenant}
          vehicle={selectedVehicle}
          closeModal={setOpenEquipmentsModal}
        />
      )}
      {openChecklistModal && (
        <ChecklistModal
          tenant={tenant}
          chooseVehicle={chooseVehicle}
          openChecklistModal={openChecklistModal}
          setOpenChecklistModal={setOpenChecklistModal}
        />
      )}
      {firstFueling && (
        <FirstFueling
          firstFueling={firstFueling}
          setFirstFueling={setFirstFueling}
          fuelingData={fuelingData}
          vehicleId={vehicleId}
        />
      )}
      {openVehicleCommandData && (
        <CviFormDialogWrapper
          open={openVehicleCommandData}
          paramValues={{ ...selectedVehicle, ...{ 'carVin': selectedVehicle.vin } }}
          onClose={() => {
            console.log('close');
            setOpenVehicleCommandData(!openVehicleCommandData)
          }}
          onSubmit={(env: any) => {
            console.log('This is a function inside defaultInitialValues' + JSON.stringify(env));
            setOpenVehicleCommandData(!openVehicleCommandData)
          }}
        />
      )}

      <EditVehicle
        open={showEdit}
        tireType={tireType}
        onClose={toggleEdit}
        vehicleId={vehicleId}
        updateDatasourceDamage={setFilter}
      />

      {openDownloadModal && (
        <DownloadModal setOpenDownloadModal={setOpenDownloadModal} />
      )}
      {openDownloadModalMassiveLock && (
        <DownloadModalMassiveLock setOpenDownloadModal={setOpenDownloadModalMassiveLock} />
      )}
    </>
  );
};

export default VehicleCarSharingSearch;
